const B = 'https://khansayazidi.tn/assets/Accessoires';
const resolve = (items) => items.map(item => ({
  ...item,
  img: `${B}/${item.folder}/${item.imgs[0]}`,
  images: item.imgs.map(f => `${B}/${item.folder}/${f}`),
}));

const BOUGEOIRS = [{
    name: 'Bougeoirs Muraux Lines',
    folder: 'Bougeoirs/Bougeoirs muraux Lines',
    imgs: ['33.webp'],
    material: `Bougeoirs muraux Lines en acier epoxy teinte doré.

Composé d'un set de trois grandeurs.

Teintes au choix. `
  },
  {
    name: 'Bougeoirs à Poser Lines',
    folder: 'Bougeoirs/Bougeoirs à poser Lines',
    imgs: ['00010.webp'],
    material: `Bougeoirs à poser Lines en acier epoxy teinte doré.

Teintes au choix. `
  },
];
const ETAGERE = [{
  name: 'Étagère de Douche',
  folder: 'Etagere de douche',
  imgs: ['10.webp'],
  material: ` `
}, ];
const MIROIRS = [{
    name: 'Miroir Mural Anneaux',
    folder: 'Miroirs/miroir mural anneaux',
    imgs: ['miroir_mural_anneaux.webp'],
    material: `Miroir mural Anneaux en acier epoxy doré

Teinte au choix.

Fourni avec un vis en L doré. `
  },
  {
    name: 'Miroir Mural Architectural',
    folder: 'Miroirs/miroir mural architectural',
    imgs: ['miroir_architectural.webp', 'miroir_mural_architecturaal.webp'],
    material: `Miroir mural Architectural en acier epoxy doré

Teinte au choix.

Fourni avec un vis en L doré. `
  },
  {
    name: 'Miroir Mural Capsule',
    folder: 'Miroirs/miroir mural capsule',
    imgs: ['DSC_0486.webp'],
    material: `Miroir mural Capsule en acier epoxy doré

Teinte au choix.

Fourni avec un vis en L doré. `
  },
  {
    name: 'Miroir Mural Capsule Carré',
    folder: 'Miroirs/Miroir mural Capsule carré 1m10 _80cm',
    imgs: ['sdb_ben_mbarek1.webp', 'sdb_ben_mbarek2.webp'],
    material: ` `
  },
  {
    name: 'Miroir Mural Capsule Ciselé',
    folder: 'Miroirs/miroir mural capsule ciselé',
    imgs: ['IMG_0603.webp', 'IMG_0879.webp', 'IMG_0901.webp', 'IMG_3414.webp'],
    material: `Miroir mural Capsule ciselé en acier epoxy doré

Teinte au choix.

Fourni avec un vis en L doré.`
  },
  {
    name: 'Miroir Mural Doura',
    folder: 'Miroirs/miroir mural doura',
    imgs: ['IMG_2011.webp', 'IMG_2025.webp'],
    material: ` `
  },
  {
    name: 'Miroir Mural Heritage',
    folder: 'Miroirs/miroir mural Heritage',
    imgs: ['2.webp'],
    material: ` `,
    collection: 'Héritage'
  },
  {
    name: 'Miroir Mural Lines',
    folder: 'Miroirs/miroir mural Lines',
    imgs: ['001.webp'],
    material: `Miroir à poser Lines en laiton massif.

Disponible en doré et chromé.`
  },
  {
    name: 'Miroir Mural Lines Carré',
    folder: 'Miroirs/miroir mural Lines carré',
    imgs: ['miroir_rectangulaire_lines.webp'],
    material: `Miroir mural Lines rectangulaire en acier epoxy doré

Teinte au choix.

Fourni avec un vis en L doré. `
  },
  {
    name: 'Miroir Mural Oval',
    folder: 'Miroirs/miroir mural Oval',
    imgs: ['11.webp'],
    material: `Miroir mural Oval en acier epoxy doré

Teinte au choix.

Fourni avec un vis en L doré. `
  },
  {
    name: 'Miroir Mural Soleil',
    folder: 'Miroirs/Miroir mural soleil',
    imgs: ['4 (2).webp', 'IMG_0247.webp', 'IMG_3713.webp'],
    material: `Miroir mural Rayons en acier epoxy doré

Teinte au choix.

Fourni avec un vis en L doré. `
  },
  {
    name: 'Miroir Mural Sunny',
    folder: 'Miroirs/miroir mural Sunny',
    imgs: ['miroir_soleil_inversé.webp'],
    material: `Miroir mural Sunny en acier epoxy doré

Teinte au choix.

Fourni avec un vis en L doré. `
  },
  {
    name: 'Miroir à Poser Arc',
    folder: 'Miroirs/miroir à poser arc',
    imgs: ['6_nc.webp'],
    material: `Miroir à Poser Arc en acier epoxy doré

Teinte au choix. `
  },
  {
    name: 'Miroir à Poser Lines',
    folder: 'Miroirs/miroir à poser Lines',
    imgs: ['fete_des_meres.webp'],
    material: `Miroir mural Lines en acier epoxy doré

Teinte au choix.

Fourni avec un vis en L doré. `
  },
];
const PORTE_SAVONS = [{
    name: 'Porte-Savon Heritage avec Tiroir',
    folder: 'Porte-savons/porte savon Heritage avec tiroir',
    imgs: ['7.webp', '8.webp'],
    material: ` `,
    collection: 'Héritage'
  },
  {
    name: 'Porte-Savon Mural Houta',
    folder: 'Porte-savons/porte savon mural Houta',
    imgs: ['porte_savon_houta1.webp'],
    material: `Porte savon mural Houta en laiton massif.

Disponible en doré et chromé.

Fourni avec des vis en laiton. `
  },
  {
    name: 'Porte-Savon Mural Houta avec Tiroir',
    folder: 'Porte-savons/porte savon mural Houta avec tiroir',
    imgs: ['porte_savon_houta_tiroir1.webp', 'IMG_4483.webp'],
    material: `Porte savon mural Houta avec tiroir en laiton massif.

Disponible en doré et chromé.

Fourni avec des vis en laiton.`
  },
  {
    name: 'Porte-Savon Mural Rayons',
    folder: 'Porte-savons/porte savon mural Rayons',
    imgs: ['2.webp', 'porte_savon_rayons1.webp'],
    material: `Porte savon mural Rayons en laiton massif 

Disponible en doré et chromé

Fourni avec des vis en laiton  `
  },
  {
    name: 'Porte-Savon Rayons à Poser',
    folder: 'Porte-savons/porte savon Rayons à poser',
    imgs: ['0005.webp'],
    material: `Porte savon à poser Rayons avec plateau en laiton massif

Disponible en doré et chromé`
  },
  {
    name: 'Porte-Savon à Poser Arc',
    folder: 'Porte-savons/porte savon à poser Arc',
    imgs: ['accessoires_ensemble1.webp', 'porte_savon_arc.webp'],
    material: `Porte savon à poser en marbre serti d'un collier en laiton massif

Laiton disponible en doré et en chromé

Marbre disponible en Thala gris, Thala beige et Gris Foussana`
  },
  {
    name: 'Porte-Savon à Poser Curved',
    folder: 'Porte-savons/Porte savon à poser Curved',
    imgs: ['1DSC_0162.webp', '2DSC_0160.webp'],
    material: `Porte savon à poser avec un bol en marbre sur un socle en laiton massif

Laiton disponible en doré et en chromé

Marbre disponible en Thala gris, Thala beige et Gris Foussana`
  },
  {
    name: 'Porte-Savon à Poser Lines',
    folder: 'Porte-savons/porte savon à poser Lines',
    imgs: ['DSC_0438.webp', 'porte_savon_poser_marbre_lines.webp'],
    material: `Porte savon à poser en marbre serti d'un collier en laiton massif 

Laiton disponible en doré et en chromé

Marbre disponible en Thala gris, Thala beige et Gris Foussana

`
  },
  {
    name: 'Porte Savon-Serviette Houta',
    folder: 'Porte-savons/Porte savon-serviette Houta',
    imgs: ['IMG_0259.webp', 'IMG_0738.webp', 'IMG_4365.webp'],
    material: ` `
  },
  {
    name: 'Porte Savon-Serviette Square',
    folder: 'Porte-savons/Porte savon-serviette Square',
    imgs: ['DSC_0200.webp', 'DSC_0235 (2).webp'],
    material: `Porte savon-serviette mural Square en marbre et laiton massif

Laiton disponible en doré et en chromé

Marbre disponible en Thala gris, Thala beige et Gris Foussana

Fourni avec des vis en laiton  `
  },
];
const PORTE_SERVIETTES = [
  {
    name: 'Porte-Serviette Houta Double',
    folder: 'Porte-serviettes/Porte serviette Houta double',
    imgs: ['porte_serviette_mural_houta.webp'],
    material: `Porte serviettes mural Houta Double portants en laiton massif.

Laiton disponible en doré et chromé.

Fourni avec ses vis en laiton. `
  },
  {
    name: 'Porte-Serviette Houta Simple',
    folder: 'Porte-serviettes/porte serviette Houta simple',
    imgs: ['66.webp', 'img2.webp', 'IMG_4562.webp', 'IMG_4566.webp'],
    material: `Porte serviettes mural Houta simple portant en laiton massif.

Laiton disponible en doré et chromé.

Fourni avec ses vis en laiton. `
  },
  {
    name: 'Distributeur Serviettes Houta',
    folder: 'Porte-serviettes/distributeur de serviettes de bain Houta',
    imgs: ['distributeur_serviettes_bain.webp'],
    material: `Distributeur serviettes de bain Houta en laiton massif.

Laiton disponible en doré et chromé.

Fourni avec ses vis en laiton.

 `
  },
  {
    name: 'Porte-Serviettes et Caps Houta',
    folder: 'Porte-serviettes/Porte serviettes et caps de bain Houta',
    imgs: ['44.webp', 'IMG_4499.webp'],
    material: `Porte serviettes de bain Houta en laiton massif.

Laiton disponible en doré et chromé.

Fourni avec ses vis en laiton. `
  },
  {
    name: 'Porte-Serviettes et Caps Arc',
    folder: 'Porte-serviettes/porte serviettes et caps de bains Arc',
    imgs: ['PSX_20241205_171346.webp'],
    material: ` `
  },
  {
    name: 'Niche Murale Demi Lune',
    folder: 'Porte-serviettes/Niche murale demi lune',
    imgs: ['niche_mural_demi_lune.webp'],
    material: `Niche murale Demi lune en Acier Epoxy.

Couleur de l'Acier epoxy au choix.

Fourni avec ses vis en laiton. `
  },
  {
    name: 'Porte-Serviettes Demi Lune',
    folder: 'Porte-serviettes/porte serviettes demi lune',
    imgs: ['porte_serviette_demi_lune.webp'],
    material: `Porte serviettes mural Demi lune en laiton massif.

Laiton disponible en doré et chromé.

Fourni avec ses vis en laiton.

 `
  },
  {
    name: 'Porte Savon-Serviette Houta',
    folder: 'Porte-serviettes/porte savon-serviette Houta',
    imgs: ['IMG_0207.webp', 'IMG_3698.webp', 'IMG_4365.webp'],
    material: ` `
  },
  {
    name: 'Porte Savon-Serviette Square',
    folder: 'Porte-serviettes/porte savon-serviette Square',
    imgs: ['DSC_0202.webp', 'DSC_0265.webp'],
    material: `Porte savon-serviette mural Square en marbre et laiton massif

Laiton disponible en doré et en chromé

Marbre disponible en Thala gris, Thala beige et Gris Foussana

Fourni avec des vis en laiton  `
  },
  {
    name: 'Porte-Serviette Heritage',
    folder: 'Porte-serviettes/porte serviette Heritage',
    imgs: ['PSX_20241205_180714.webp', 'PSX_20241211_122126.webp'],
    material: ` `,
    collection: 'Héritage'
  },
  {
    name: 'Porte-Serviettes à Poser Lines',
    folder: 'Porte-serviettes/Porte serviettes à poser Lines',
    imgs: ['porte_serviette_a_poser_foussana1.webp', 'porte_serviette_a_poser_foussana2.webp', 'porte_serviette_a_poser_gris1.webp', 'porte_serviette_a_poser_gris2.webp'],
    material: `Porte serviettes à poser Lines avec son fin plateau en marbre Thala gris serti d'arcades en acier epoxy teinte doré.

Marbre disponible en Thala gris et Gris Foussana.

Couleur de l'Acier epoxy au choix.`
  },
  {
    name: 'Boutons Accroches Serviette Lines',
    folder: 'Porte-serviettes/boutons accroches serviette Lines',
    imgs: ['88.webp', 'IMG_1936.webp', 'IMG_2067.webp'],
    material: ` `
  },

];
const PORTE_BROSSES = [{
  name: 'Porte-Brosses',
  folder: 'Porte_brosses',
  imgs: ['porte_brosses1.webp'],
  material: `Porte brosse à poser en marbre serti d'un collier en laiton massif.

Laiton disponible en doré et chromé.

Marbre disponible en Thala gris, Thala beige, Gris Foussana. `
}, ];
const PAPIER_TOILETTE = [{
    name: 'Porte Papier Toilette Houta',
    folder: 'Portes papier toilette/porte papier toilette Houta',
    imgs: ['porte_papier_houta.webp', 'IMG_3689.webp'],
    material: `Porte papier toilette mural Houta en laiton massif

Disponible en doré et chromé. `
  },
  {
    name: 'Porte Papier Toilette Reliefs',
    folder: 'Portes papier toilette/Porte papier toilette Reliefs',
    imgs: ['porte_papier_chromé.webp'],
    material: `Porte papier toilette mural Reliefs en laiton massif chromé.

Disponible en doré et chromé.

 `
  },
];

export const bougeoirs = resolve(BOUGEOIRS);
export const etagereDouche = resolve(ETAGERE);
export const miroirs = resolve(MIROIRS);
export const porteSavons = resolve(PORTE_SAVONS);
export const porteServiettes = resolve(PORTE_SERVIETTES);
export const porteBrosses = resolve(PORTE_BROSSES);
export const portesPapierToilette = resolve(PAPIER_TOILETTE);
export const allAccessoires = [...bougeoirs, ...etagereDouche, ...miroirs, ...porteSavons, ...porteServiettes, ...porteBrosses, ...portesPapierToilette];